var Backbone = require('backbone'),
     _ = require('underscore'),
    Raphael = require('raphael'),
    $ = require('jquery'),
    ShapeUIModel = require('./shapeUI'),
    ShapeTransformModel = require('./shapeTransformModel/shapeTransformModel'),
    fvChannel = require('glRadio').channel('FV');


module.exports = Backbone.Model.extend({

    ShapeUIModel: ShapeUIModel, // shapeUIModel set on parse; flag on here for subclasses rather than use of factory

    placedOpacity: 1, // the opacity at which the shape should be when placed atop the page/image (differs from the fill-opacity) -- should prob put on shapeUIModel

    hasCustomizableProperties: 0, // flag if the shape type has user customizable zone properties (eg to show an interface in the UI for them -- like a dialog)

    VIEW_SUPPORTS_TRANSFORM: 0, // transitionary refactor

    ALLOW_DRAG_OFF_CANVAS: 0,


    constructor: function(attrs, options) {

        delete this.id;   // bypass sync when deleting to avoid error
        options || (options = {});
        options.parse = true; // always parse -- these are UI models

        /*
        *  Note: these are set on parse; put here for definition clarity
        *  ( don't put in initialize, which is called after parse )
        * */
        this.parentNote = null;
        this.pageModel = null;
        this.uiModel = null;

        this.transformModel = this.shapeViewSupportsTransforms() ? new ShapeTransformModel() : null;

        /*
        * zoneColor: the actual color of the zone; what is persisted in the DB and set by color pickers.
        * It is 'live': for applicable shapes, updated on color picker change.
        * Not necessarily what is shown in the UI ( it could be overwritten by consult group color, group color -- see canvas.getColorToApplyToShape )
        * We need to revert to the 'original'/live zone color if any override is removed.
        * Set on:
        * 1) model parse: from db or from newly drawn shape
        * 2) color-picker change when the shape is selected (for applicable note types that support it )
        * */
        this.zoneColor = null;

        return Backbone.Model.prototype.constructor.apply(this, arguments);

    },

    /*
    * Note: this is a fn so can we can reference fvChannel to get the last redaction fill (if not, wiring wouldn't yet be set up
    * */
    defaults: function() {
        return {};
    },

    /*
    * When refactor Canvas Module, maybe just handle this in the constructor for more simplicity.
    * */
    parse: function( attrs, options ) {

        this.parentNote = options.parentNote;
        this.pageModel = options.pageModel;

        // Set a unique id that we can use to distinguish and remember between renders
        // Use cid -- these are UI models
        // Don't use id -- see comment above for shape.destroy; also can continue to reference unique shapes by cid
        attrs.uid = this.parentNote.cid + '_' + options.shapeIndexOfNote;

        this.uiModel = new this.ShapeUIModel(
            _.extend( {}, _.pick( options, 'isActive', 'isExpanded', 'isNewlyDrawn'), {
                raphaelEl: options.raphaelEl
            })
        );

        this.setZoneColorOnParse.apply( this, arguments );

        return attrs;

    },

    setZoneColorOnParse: $.noop,

    /*
    * The 'shape' attributes to save on the note model gathered from the newly saved shapes.
    * Called from the shapes collection.
    * Overwritten but left here for clarity.
    * */
    getAttrsToPersist: function() {
       return {};
    },

    /*
    * Can't put on note level 'defaultSVGAttrs' because this is now at the shape level (diff fills can have diff types) !
    * ( Also now implementing the zone color stored in EDSTOR ).
    * Larger refactor: move defaultSVGAttributes from the note model to the shape model.
    * */
    getNonPathInactiveSVGAttrs: $.noop,

    getNonPathActiveSVGAttrs: $.noop,

    /*
    * Left for clarity -- always overwritten: get the Raphael path to render from shapeView renderFromModel
    * */
    getPathToRenderFromModel: $.noop,

    isChildOfNote: function(note) {

        return note.cid === this.parentNote.cid;

    },
    getParentNote: function() {
        return this.parentNote;
    },

    getZoneColor: function() {
        return this.zoneColor;
    },

    setZoneColor: function( color ) {
        this.zoneColor = color;
    },

    /*
    * Returns if the shape's path should be closed / or not (can tell by combo of isRect and note type )
    * existing: on draw come from imgCanvas allNotes.get(shape.parentNoteId) ? allNotes.get(shape.parentNoteId) :.get('activeNote') -- should change
    * Not stored; get from the current pts or a new shape w/out them (param)
    * TODO: still necessary? ... I think area for refactor
    *
    * true: rectangles and polygon redactions should close
    * false: 'free', 'line', 'line-dashed', 'line-arrow'
    * */
    shouldCloseElementPath: function(pts, parentNoteType) {

        var isRect = Raphael.fn.isRect( pts || this.get('points') ),
            pNoteType = parentNoteType ? parentNoteType : this.getParentNote().get('noteType');

        // TODO: should use .isRedactionNote but larger refactor imminent
        return isRect || ( pNoteType === 'REDACTION_NOTE' || pNoteType === 'FLOATING_REDACTION_NOTE' );

    },

    /*
    * Used to determine the sub-shape type on click of the base shape view.
    * el: used for those whose model doesn't yet exist.
    * TODO:
    *  - id and use data-type in svg or gd forbid actually help this client by giving storage in the DB.
    *  - Logic here can be simplified if every note type has it's own shape.
    * */
    deriveShapeSubType: function(el) {

        var parentNote = this.getParentNote(),
            noteType = parentNote ?
                parentNote.get('noteType')
                : this.vChannel.request('activeNote').get('noteType'),  // can't just use this.getParentNote; if new not yet added to shapes collection
            el = el ? el : this.uiModel.raphaelEl(), // can't get if not yet rendered -- so get from canvas Controller (?)
            subType;

        // TODO: change to using the note model and then functions that encapsulate the enums
        switch(noteType) {

            case 'SVG_SIGNATURE':
                subType = 'signature';
                break;

            case 'GRAPHIC_TEXT_STAMP':
                subType = 'text_stamp'; // could also use get default subType from the note model ...
                break;
            // TODO: would want to use fn here ...isRedactionNote() ... change from switch statement
            // though if refactoring should handle this another way, eg, custom data-attribute ... need to revisit how this works
            case 'REDACTION_NOTE':
            case 'FLOATING_REDACTION_NOTE':
                subType = el.pathIsRect() ? 'rect' : 'poly';
                break;

            case 'SVG_GRAPHIC_NOTE':
                subType = this.determineGraphicNoteShapeSubType(el.attrs);
                break;

            default:
                subType = 'rect';
                break;
        }

        return subType;

    },

    /**
     * Return the sub-shape type of a graphic note from attrs.
     * Attrs are those supported (and in use by the Raphael.js library.
     * The caller either passes them from an existing DOM element or from those stored in the DB.
     * All elements are paths.
     * On baseShape due to legacy architechture --
     * This design should change -- the placement here is just a small compromise to consolidate
     * logic that used to exist in 2 places.
     */
    determineGraphicNoteShapeSubType: function(attrs) {

        var pathIsRect = Raphael.fn.isRect( Raphael.fn.getPathCoordinates(attrs.path) );
        var subType;

        // Distinguish rectangles from other types
        if ( pathIsRect ) {

            // Note: fill-opacity can be a string (DVBC-1478)
            var fillOpacity = attrs['fill-opacity'];
            subType = fillOpacity && parseFloat(fillOpacity) === 0
                ? 'rect-nofill'
                : 'rect-fill';
        }
        else // line is a polygon; only others is free & text
        {
            if ( Raphael.fn.pathIsLine( attrs.path ) ) {

                if ( _.has( attrs , 'arrow-end')) {

                    subType = 'line-arrow';

                } else if ( _.has( attrs, 'stroke-dasharray')) {

                    subType = 'line-dashed';
                } else {

                    subType = 'line';
                }

            } else if ( _.has( attrs, 'font-family') ) {

                subType = 'text';
            } else {

                subType = 'free';
            }
        }

        return subType;

    },

    getPathToRender: function(scale) {
        return Raphael.fn.getPathFromPtsArray(
            this.getAdjustedPointsArray(scale, this.parentNote),
            this.shouldCloseElementPath()
        );
    },

    getHasCustomizableProperties: function() {
        return this.hasCustomizableProperties;
    },


    shapeViewSupportsTransforms: function() {
        return this.VIEW_SUPPORTS_TRANSFORM;
    },

    allowDragOffCanvas: function() {
        return this.ALLOW_DRAG_OFF_CANVAS;
    },

    getTransformModel: function() {
        return this.transformModel;
    },

    destroy: function() {

        Backbone.Model.prototype.destroy.call(this);
        this.uiModel.destroy();

    }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/baseShape.js
 ** module id = 254
 ** module chunks = 0
 **/